
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.185 12.202c-6.3 8-12.6 16-19 24-1.1 1.3-2.1 3.1-3.4 4.3l-.2.2c-.5-.4-1.3-1.4-1.6-1.7-3.6-3.8-7.3-7.5-11-11.2-.9-.9-1.3 2.1-.7 2.7l13.2 13.2c.2.2.5.3.7 0l22.8-28.8c.5-.7 0-3.7-.8-2.7z"}})])
          )
        }
      }
    